import {alias, list, createModelSchema} from "serializr";
import {Schema} from "@/common/Schema";

import {SmartOfferBundle} from "../bundle-core/SmartOfferBundle";
import {SmartOfferBundleKind} from "../bundle-core/SmartOfferBundleKind";
import {RewardTrack} from "@/modules/redactor/models/reward/RewardTrack";
import {ProductTrackModel} from "@/modules/redactor/models/product/ProductTrackModel";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

export class SmartOfferBundleHub extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.HUB);

        this._rewardTrack = null;
        this._productTrack = null;

        this._productBonus = null;

        this._eventOffers = [];
        this._shopOffers = [];
    }

    get rewardTrack() {
        return this._rewardTrack;
    }

    set rewardTrack(value) {
        this._rewardTrack = value;
    }

    get productTrack() {
        return this._productTrack;
    }

    set productTrack(value) {
        this._productTrack = value;
    }
    
    get productBonus() {
        return this._productBonus;
    }

    set productBonus(value) {
        this._productBonus = value;
    }

    get eventOffers() {
        return this._eventOffers;
    }

    set eventOffers(value) {
        this._eventOffers = value;
    }

    get shopOffers() {
        return this._shopOffers;
    }

    set shopOffers(value) {
        this._shopOffers = value;
    }

    valid() {
        if (!super.valid()) {
            console.log("super invalid");
            return false;
        }

        if (!this.rewardTrack || !this.rewardTrack.valid()) {
            console.log("rewardTrack invalid");
            return false;
        }

        if (!this.productTrack || !this.productTrack.valid()) {
            console.log("productTrack invalid");
            return false;
        }

        if (!this.productBonus || !RedactorUtils.getProduct(this.productBonus)) {
            console.log("productBonus invalid");
            return false;
        }

        // Validate event offers - no empty entries allowed
        for (let i = 0; i < this.eventOffers.length; i++) {
            const offerString = this.eventOffers[i];
            if (!offerString || offerString.trim() === '') {
                console.log(`eventOffers[${i}] invalid: ${offerString}`);
                return false;
            }
        }

        // Validate shop offers - no empty entries allowed
        for (let i = 0; i < this.shopOffers.length; i++) {
            const offerString = this.shopOffers[i];
            if (!offerString || offerString.trim() === '') {
                console.log(`shopOffers[${i}] invalid: ${offerString}`);
                return false;
            }
        }

        return true;
    }

    empty() {
        
        if (!this.rewardTrack || this.rewardTrack.empty()) {
            return true;
        }

        if (!this.productTrack || this.productTrack.empty()) {
            return true;
        }

        if (!this.productBonus || !RedactorUtils.getProduct(this.productBonus)) {
            return true;
        }

        return super.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleHub());
        } else if (target instanceof SmartOfferBundleHub) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleHub, {
    
    _rewardTrack: alias("reward_track", RewardTrack.schema()),

    _productTrack: alias("track", ProductTrackModel.schema()),
    
    _productBonus: alias("product_bonus", Schema.primitive()),

    _eventOffers: alias("event_offers", list(Schema.primitive())),

    _shopOffers: alias("shop_offers", list(Schema.primitive())),
});